/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
//component
import Button from "../../../components/Button";
import IconButton from "../../../components/Button/IconButton";
import { Row, Col } from "../../../components/ContentLayout";
import Modal, { ModalHeader } from "../../../components/Modal";
import SelectInput from "../../../components/Select-Input";
import Select from "../../../components/Select";
import Textarea from "../../../components/Textarea";
// hook
import useForm from "../../../hooks/useForm";
// api
import { getSalariesItemsList } from "../../../apis/salary/salary-items";
// utils
import { forEach, isEmpty, isUndefined } from "lodash-es";
import DeleteIcon from "../../../assets/images/icon/delete-icon-01.svg";
import { transformComma, restoreComma } from "../../../utils/validator/comma";
import { searchEmployee } from "../../../utils/employee";
import { get, sortBy } from "lodash";
import DatePicker from "../../../components/DatePicker";
import { createSalariesHistories, modifySalariesHistories } from "../../../apis/salary/salary-history";
import { dateToFormat, getMonth } from "../../../utils/date";
// import { getYear } from "../../../utils/date";

const PAY_TYPES = [
  { label: "월급", value: "월급" },
  { label: "주급", value: "주급" },
  { label: "일급", value: "일급" },
  { label: "상여금", value: "상여금" },
  { label: "퇴직금", value: "퇴직금" },
];

const selctOption = (list) => {
  return (
    <>
      {!isEmpty(list) &&
        list.map(({ name, code }, idx) => (
          <option key={idx} value={code}>
            {name}
          </option>
        ))}
    </>
  );
};

const SalaryHistory = ({ mode = "create", open, setOpen, submit, params, list, setList }) => {
  const { employees } = useSelector((store) => ({
    employees: store.Data.employees,
  }));
  //const [employeeInfo, setEmployeeInfo] = useState({});
  const [targetEmployee, setTargetEmployee] = useState([]);

  const [allowanceList, setAllowanceList] = useState([]);
  const [allowances, setAllowances] = useState([]);
  const [deductionList, setDeductionList] = useState([]);
  const [deductions, setDeducations] = useState([]);
  const [totalAllowance, setTotalAllowance] = useState(0);
  const [totalDeducation, setTotalDeducation] = useState(0);
  const [payMonth, setPayMonth] = useState([]);

  const validate = ({ employeeIdx, description }) => {
    let errors = {};

    return errors;
  };

  useEffect(() => {
    // const year = new Date().getFullYear();
    setPayMonth([
      { label: getMonth(undefined, 6, 'YYYY.MM'), value: getMonth(undefined, 6, 'YYYY-MM') },
      { label: getMonth(undefined, 5, 'YYYY.MM'), value: getMonth(undefined, 5, 'YYYY-MM') },
      { label: getMonth(undefined, 4, 'YYYY.MM'), value: getMonth(undefined, 4, 'YYYY-MM') },
      { label: getMonth(undefined, 3, 'YYYY.MM'), value: getMonth(undefined, 3, 'YYYY-MM') },
      { label: getMonth(undefined, 2, 'YYYY.MM'), value: getMonth(undefined, 2, 'YYYY-MM') },
      { label: getMonth(undefined, 1, 'YYYY.MM'), value: getMonth(undefined, 1, 'YYYY-MM') },
      { label: getMonth(undefined, 0, 'YYYY.MM'), value: getMonth(undefined, 0, 'YYYY-MM') },
      { label: getMonth(undefined, -1, 'YYYY.MM'), value: getMonth(undefined, -1, 'YYYY-MM') },
      { label: getMonth(undefined, -2, 'YYYY.MM'), value: getMonth(undefined, -2, 'YYYY-MM') },
      { label: getMonth(undefined, -3, 'YYYY.MM'), value: getMonth(undefined, -3, 'YYYY-MM') },
      { label: getMonth(undefined, -4, 'YYYY.MM'), value: getMonth(undefined, -4, 'YYYY-MM') },
      { label: getMonth(undefined, -5, 'YYYY.MM'), value: getMonth(undefined, -5, 'YYYY-MM') },
      { label: getMonth(undefined, -6, 'YYYY.MM'), value: getMonth(undefined, -6, 'YYYY-MM') },
    ]);
  }, []);

  const _submit = (form) => {
    const transForm = {
      ...form,
      payFor: `${form.payMonth}-01`,
      deductionList: form?.deductionList.map(item => {
        return {
          ...item,
          value: restoreComma(item.value)
        };
      }),
      allowanceList: form?.allowanceList.map(item => {
        return {
          ...item,
          value: restoreComma(item.value)
        };
      }),
    };
    // TODO 예외처리 필요

    if (mode === "create") {
      createSalariesHistories(transForm).then(() => {
        setOpen(false);
        submit(params);
      });
    } else {
      const transFormUpdate = {
        ...form,
        payFor: `${form.payMonth}-01`,
        allowanceList: allowanceList.map((allowance) => { return { name: allowance.name, value: restoreComma(allowance.value) }; }),
        deductionList: deductionList.map((deduction) => { return { name: deduction.name, value: restoreComma(deduction.value) }; }),
      };
      modifySalariesHistories(list.idx, transFormUpdate).then(() => {
        setList({});
        setOpen(false);
        submit(params);
      });
    }
  };

  const {
    form,
    setForm,
    // errors,
    handleOnChange,
    handleSubmit,
    reset,
  } = useForm(
    {
      employeeIdx: "",
      employeeCode: "",
      payType: "월급",
      payMonth: dateToFormat(undefined, "YYYY-MM"),
      payDate: "",
      exposureDate: "",
      totalAllowance: 0,
      totalDeduction: 0,
      paymentByDifference: "",
      allowanceList: [
        {
          idx: "",
          code: "",
          value: "",
        },
      ],
      deductionList: [
        {
          idx: "",
          code: "",
          value: "",
        },
      ],
      description: "",
    },
    _submit,
    validate
  );

  const setSalaryHistory = (data) => {
    //console.log("data: ", data)

    //targetEmployee
    const emplyee = employees.find((employee) => employee.idx === data.employeeIdx);
    setTargetEmployee([emplyee]);

    setForm({
      ...form,
      employeeIdx: emplyee.idx,
      employeeCode: emplyee.code,
      description: isEmpty(get(data, "description")) ? "" : get(data, "description"),
      payType: get(data, "payType"),
      payDate: get(data, "payDate"),
      exposureDate: get(data, "exposureDate"),
      payMonth: dateToFormat(get(data, "payFor"), "YYYY-MM")
    });

    setAllowanceList(data.allowanceList.map((allowance, idx) => ({ name: allowance.name, code: idx, value: transformComma(allowance.value) })));
    setDeductionList(data.deductionList.map((deduction, idx) => ({ name: deduction.name, code: idx, value: transformComma(deduction.value) })));
  };

  useEffect(() => {
    if (mode === "create") {

    } else {
      if (!isEmpty(list)) {
        setSalaryHistory(list);
      }
    }
  }, [mode, list]);

  useEffect(() => {
    getPaymentList();
    getDeducationList();
  }, [open]);

  // 지급 내역
  const getPaymentList = () => {
    getSalariesItemsList({
      search: { type: "allowance" },
    })
      .then((res) => {
        res = res.data.works.filter((work) => work.isActive === true).map((work) => ({
          name: work.name,
          idx: work.idx,
          code: work.code,
          value: "",
        }));

        const initAllowanceList = res.filter((data) => data.code === "1001");
        //setAllowances(res);
        //console.log("res: ", res)
        setAllowances(sortBy(res, ['code']));
        if (mode === "create") {
          setAllowanceList(initAllowanceList);
        }
        // setForm({ ...form, allowanceList: initAllowanceList });
      })
      .catch((err) => {
        console.error(err);
      });
  };
  // 공제 내역
  const getDeducationList = () => {
    getSalariesItemsList({
      search: { type: "deduction" },
    })
      .then((res) => {
        res = res.data.works.filter((work) => work.isActive === true).map((work) => ({
          name: work.name,
          idx: work.idx,
          code: work.code,
          value: "",
        }));

        const initDeducationList = res.filter((data) => data.code === "5001");
        //setDeducations(res);
        setDeducations(sortBy(res, ['code']));
        if (mode === "create") {
          setDeductionList(initDeducationList);
        }
        // setForm({ ...form, deductionList: initDeducationList });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleSearchEmployee = () => {
    searchEmployee(
      (employee) => {
        setTargetEmployee(employee);
      },
      targetEmployee,
      { isSingle: true }
    );
  };

  useEffect(() => {
    if (!isEmpty(targetEmployee)) {
      setForm({
        ...form,
        employeeIdx: targetEmployee[0].idx,
        employeeCode: targetEmployee[0].code,
      });
    }
  }, [targetEmployee]);

  const handleAddPayment = (type) => {
    let idx;
    switch (type) {
      case "allowance":
        idx = allowanceList.length;
        if (isUndefined(allowances[idx])) {
          if (mode === "create" || isUndefined(allowances[0])) return;
          setAllowanceList((oldVal) => [...oldVal, allowances[0]]);
          return;
        }
        setAllowanceList((oldVal) => [...oldVal, allowances[idx]]);
        break;
      case "deduction":
        idx = deductionList.length;
        if (isUndefined(deductions[idx])) {
          if (mode === "create" || isUndefined(deductions[0])) return;
          setDeductionList((oldVal) => [...oldVal, deductions[0]]);
          return;
        };
        setDeductionList((oldVal) => [...oldVal, deductions[idx]]);
        break;
      default:
        break;
    }
  };

  const handleOnRemovePayment = (idx, type) => {
    if (type === "allowance") {
      setAllowanceList(
        allowanceList.filter((allowance, itemIdx) => itemIdx !== idx)
      );
    } else {
      setDeductionList(
        deductionList.filter((deduction) => deduction !== deductionList[idx])
      );
    }
  };

  const handleSelectOnChange = (e, index, type) => {
    const { name, value } = e.target;
    switch (type) {
      case "allowance":
        if (name === "code") {
          const selectValue = allowances.find((d) => d.code === value);
          const { name, idx, code } = selectValue;
          const old = allowanceList[index];
          const updated = {
            ...old,
            name,
            idx,
            code,
          };
          const clone = [...allowanceList];
          clone[index] = updated;
          setAllowanceList(clone);
        } else {
          const old = allowanceList[index];
          const updated = { ...old, value: transformComma(value) };
          const clone = [...allowanceList];
          clone[index] = updated;
          setAllowanceList(clone);
        }
        break;
      case "deduction":
        if (name === "code") {
          const selectValue = deductions.find((d) => d.code === value);
          const { name, idx, code } = selectValue;
          const old = deductionList[index];
          const updated = {
            ...old,
            name,
            idx,
            code,
          };
          const clone = [...deductionList];
          clone[index] = updated;
          setDeductionList(clone);
        } else {
          const old = deductionList[index];
          const updated = { ...old, value: transformComma(value) };
          const clone = [...deductionList];
          clone[index] = updated;
          setDeductionList(clone);
        }
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    setTotalAllowance(getTotal("allowance"));
    setTotalDeducation(getTotal("deduction"));
    setForm({
      ...form,
      totalAllowance: getTotal("allowance"),
      totalDeduction: getTotal("deduction"),
      paymentByDifference: getTotal("allowance") - getTotal("deduction"),
      allowanceList: allowanceList,
      deductionList: deductionList,
    });
  }, [allowanceList, deductionList]);

  const getTotal = (type) => {
    let total = 0;
    if (type === "allowance") {
      forEach(allowanceList, (value) => {
        total += Number(restoreComma(value.value));
      });
    } else {
      forEach(deductionList, (value) => {
        if (value.name !== "미제출비과세") {
          total += Number(restoreComma(value.value));
        }
      });
    }
    return total;
  };

  const getDifferencePay = () => {
    return getTotal("allowance") - getTotal("deduction");
  };

  const cancel = (e) => {
    e.preventDefault();
    setOpen(false);
    if (mode === "create") {
      reset();
      setAllowanceList([]);
      setDeductionList([]);
    } else {
      reset();
      setList({});
      setAllowanceList([]);
      setDeductionList([]);
    }
  };

  return (
    <Modal isOpen={open} close={cancel}>
      <div className="salary-history-write">
        <ModalHeader className="margin-bottom-32">
          {mode === "create" ? "새 급여내역" : "급여내역 수정"}
        </ModalHeader>
        <Row>
          <Col sm={6}>
            <div className="left-site-wrap">
              <div className="left-item-wrap">
                <label className="salary-history-label">급여대상 직원</label>
                <input
                  className="employee-search-btn"
                  name="employeeIdx"
                  type="button"
                  value={
                    isEmpty(targetEmployee)
                      ? "사람 선택"
                      : targetEmployee[0].name
                  }
                  onClick={handleSearchEmployee}
                />
              </div>
              <div className="left-item-wrap">
                <p className="salary-history-label">
                  안내 메세지<span className="optional-label">(선택)</span>
                </p>
                <Textarea
                  className="margin-top-12"
                  name="description"
                  value={form.description}
                  onChange={handleOnChange}
                  placeholder="급여명세서에서 전달할 안내사항을 작성할 수 있어요"
                  maxLength={100}
                  height="360px"
                />
              </div>
              <div className="left-item-wrap">
                <p className="salary-history-label">지급내역</p>

                {!isEmpty(allowanceList) &&
                  allowanceList.map((allowance, idx) => (
                    <React.Fragment key={idx}>
                      <SelectInput
                        className="margin-top-12 salary-history-select-input"
                        selectName="code"
                        inputName="value"
                        unitLabel="원"
                        inputValue={allowance.value}
                        //defaultValue={allowance.code}
                        defaultValue={idx}
                        onChange={(e) =>
                          handleSelectOnChange(e, idx, "allowance")
                        }
                        children={selctOption([allowance, ...allowances])}
                      />
                      {idx > 0 && (
                        <IconButton
                          className="delete-icon"
                          icon={DeleteIcon}
                          onClick={() =>
                            handleOnRemovePayment(idx, "allowance")
                          }
                        />
                      )}
                    </React.Fragment>
                  ))}

              </div>
              <Button
                className="salary-history-add-btn margin-top-12"
                color="gray-line"
                size="sm"
                onClick={() => handleAddPayment("allowance")}
                label="추가"
              />
            </div>
          </Col>
          <Col sm={6}>
            <div className="right-site-wrap">
              <div className="right-item-wrap">
                <label className="salary-history-label">급여 형태</label>
                <Select
                  className="pay-select"
                  name="payType"
                  value={form.payType}
                  list={PAY_TYPES}
                  onChange={handleOnChange}
                />
                <label className="salary-history-label pay-month">귀속월</label>
                <Select
                  className="pay-select month"
                  name="payMonth"
                  list={payMonth}
                  value={form.payMonth}
                  onChange={handleOnChange}
                />
              </div>
              <div className="right-item-wrap">
                <label className="salary-history-label paydate">지급일</label>
                <DatePicker
                  defaultValue={form.payDate}
                  onChange={(date) => {
                    setForm({
                      ...form,
                      payDate: date.datepicker.toString(),
                    });
                  }}
                />
              </div>
              <div className="right-item-wrap">
                <label className="salary-history-label paydate">노출일</label>
                <DatePicker
                  defaultValue={form.exposureDate}
                  onChange={(date) => {
                    setForm({
                      ...form,
                      exposureDate: date.datepicker.toString(),
                    });
                  }}
                />
              </div>
              <div className="right-item-wrap">
                <div className="pay-employee-info-wrap">
                  <div className="item-wrap">
                    <div className="item">
                      <label className="employee-info-label">부서</label>
                      <span className="employee-info-value">
                        {get(targetEmployee, "[0].partName")}
                      </span>
                    </div>
                    <div className="item">
                      <label className="employee-info-label">직급</label>
                      <span className="employee-info-value">
                        {get(targetEmployee, "[0].gradeName")}
                      </span>
                    </div>
                  </div>
                  <div className="item-wrap">
                    <div className="item">
                      <label className="employee-info-label">직원코드</label>
                      <span className="employee-info-value">
                        {get(targetEmployee, "[0].code")}
                      </span>
                    </div>
                    <div className="item">
                      <label className="employee-info-label">이름</label>
                      <span className="employee-info-value name">
                        {get(targetEmployee, "[0].name")}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="pay-info-wrap">
                  <div className="label-wrap">
                    <p className="pay-info-text">지급계(a)</p>
                    <p className="pay-info-text">공제계(b)</p>
                    <p className="pay-info-text">차인 지급계(a-b)</p>
                  </div>
                  <div className="value-wrap">
                    <p className="pay-info-text">{transformComma(totalAllowance)}</p>
                    <p className="pay-info-text">{transformComma(totalDeducation)}</p>
                    <p className="pay-info-text">
                      {transformComma(getDifferencePay())}
                    </p>
                  </div>
                </div>
              </div>
              <div className="right-item-wrap">
                <p className="salary-history-label">공제내역</p>
                {!isEmpty(deductionList) &&
                  deductionList.map((deduction, idx) => (
                    <React.Fragment key={idx}>
                      <SelectInput
                        className="margin-top-12 salary-history-select-input"
                        selectName="code"
                        inputName="value"
                        unitLabel="원"
                        inputValue={deduction.value}
                        //defaultValue={deduction.code}
                        defaultValue={idx}
                        onChange={(e) =>
                          handleSelectOnChange(e, idx, "deduction")
                        }
                        children={selctOption([deduction, ...deductions])}
                        validators={['comma']}
                      />
                      {idx > 0 && (
                        <IconButton
                          className="delete-icon"
                          icon={DeleteIcon}
                          onClick={() =>
                            handleOnRemovePayment(idx, "deduction")
                          }
                        />
                      )}
                    </React.Fragment>
                  ))}
                <Button
                  className="salary-history-add-btn margin-top-12"
                  color="gray-line"
                  size="sm"
                  onClick={() => handleAddPayment("deduction")}
                  label="추가"
                />
              </div>
            </div>
          </Col>
        </Row>
        <div className="form-button-wrap">
          <Button className="form-button" color={"text"} onClick={cancel}>
            취소
          </Button>
          <Button className="form-button" onClick={handleSubmit}>
            {mode === "create" ? "작성완료" : "수정완료"}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default SalaryHistory;

// {
//   employeeIdx: number,
//   employeeCode: string,
//   payType: string,
//   payMonth: string,
//   payDate: string,
//   totalAllowance: number,
//   totalDeduction: number,
//   paymentByDifference: number,
//   allowanceList: [
//     {
//       idx: number,
//       code: string,
//       value: number
//     }
//   ],
//   deductionList: [
//     {
//       idx: number,
//       code: string,
//       value: number
//     }
//   ],
//   description: string
// }
